<template>
  <div class="order finDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.editDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务编辑</h3>
      <div class="selectBox clearfix">
        <ny-select
          :data="financial.advertiserMenu"
          v-model="adver"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          part="adver"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-input class="searchBox" icon="search" v-model="accountName" placeholder="请输入账号名称"></el-input>
        <el-input class="searchBox" icon="search" v-model="adverName" placeholder="请输入广告主或者代理商名称"></el-input>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.editPage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        >
          <template v-if="financial.editPage.data.length>0">
            <el-table-column fixed="right" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'add')"
                  type="primary"
                  size="small"
                >加款</el-button>
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'minus')"
                  size="small"
                  class="is-refund"
                >退款</el-button>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
    </div>
    <custom-dialog :customDialog="premiumDialog" class="priceCus">
      <!-- 加款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :type="addPrice"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :setMax="setMax"
          :money="money"
          :platform="platform"
          :committing="committing"
        ></priceCus>
      </div>
    </custom-dialog>
    <custom-dialog :customDialog="refundDialog" class="priceCus">
      <!-- 退款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :type="refund"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :setMax="setMax"
          :money="money"
          :platform="platform"
          :committing="committing"
        ></priceCus>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, customDialog, priceCus } from '@/global/components';
import { post } from '@/agent/http/index'
import { mapGetters } from 'vuex';
export default {
  name: 'advertiser',
  data () {
    return {
      adver: '0',
      adverName: '',
      accountName: '',
      setMax: '',
      addPrice: {
        title: '加款金额',
        type: 'add'
      },
      refund: {
        title: '退款金额',
        type: 'refund'
      },
      rowId: {

      },
      money: {
        cash: '',
        addCash: ''
      },
      errorShow: {
        add: false,
        refund: false
      },
      platform: '',
      loading: false,
      premiumDialog: {// 加款
        visible: false,
        isClickModal: false
      },
      refundDialog: {// 退款
        visible: false,
        isClickModal: false
      },
      committing: false // 提交状态
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.platform = this.$router.currentRoute.meta.platform
      this.$store.dispatch('finance/getAdvertiserMenu', { parentId: this.userid })
      this.getEditFincialInfo()
    },
    getEditFincialInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('finance/getEditFincialTable', {
        userId: this.adver,
        parentId: this.userid,
        accountName: this.accountName,
        userName: this.adverName,
        currentPage,
        pageSize
      })
    },
    changeSelect (val) {
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getEditFincialInfo({ currentPage, pageSize })
    },
    searchData () {
      this.financial.editPage.resetData()
      this.getEditFincialInfo()
    },
    handlePrice (index, row, handleType) {
      this.rowId = row;
      if (handleType === 'add') {
        this.premiumDialog.visible = true;
        post('/agency/finance/balance', {
          user_type: 1,
          account_id: this.userid
        }).then(res => {
          if (res.code === 1) {
            this.money.addCash = res.data.data.balance
            this.setMax = res.data.data.balance
          }
        })
      } else {
        this.refundDialog.visible = true;
      }
      post('/agency/finance/balance', {
        user_type: this.rowId.user_type,
        account_id: this.rowId.id
      }).then(res => {
        if (res.code === 1) {
          this.money.cash = res.data.data.cash_balance
          if (handleType !== 'add') {
            this.setMax = res.data.data.cash_balance
          }
        }
      })
    },
    surePrice ({ handleType, form }) {
      this.committing = true
      let data = {}
      let self = this
      if (handleType === 'add') {
        data.account_id = this.userid
        data.user_type = 1
      } else {
        data.account_id = self.rowId.id
        data.user_type = self.rowId.user_type
      }
      post('/agency/finance/balance', data).then(res => {
        if (res.code === 1) {
          if (res.data.data.balance >= parseInt(form.price)) {
            self.errorShow.add = false
            let params = {}
            params.user_id = self.rowId.id
            params.p_id = self.userid
            params.money = form.price
            params.ext = form.remark
            params.user_type = self.rowId.user_type
            params.name = self.rowId.name
            params.type = handleType === 'add' ? 1 : 2
            params.account_id = self.userid
            post('/agency/finance/money', params).then(res => {
              self.committing = false
              if (res.code === 1) {
                if (handleType === 'add') {
                  self.premiumDialog.visible = false;
                  self.$message('加款成功')
                } else {
                  self.refundDialog.visible = false;
                  self.$message('退款成功')
                }
                self.getEditFincialInfo()
                const platformMap = {
                  'agency': '1',
                  'ka': '2',
                  'admin': '3',
                  'ad-user': '4'
                }
                let platform = this.$router.options.routes[0].meta.platform
                this.$store.dispatch('login/getBalance', {
                  platform: platform,
                  data: {
                    account_id: this.userid,
                    user_type: platformMap[platform]
                  }
                })
              } else {
                self.$message(res.msg)
                self.committing = false
              }
            }).catch(() => {
              self.committing = false
            })
          }
        } else {
          self.errorShow.add = true
        }
      })
    },
    cancelPrice ({ handleType }) {
      if (handleType === 'add') {
        this.premiumDialog.visible = false;
      } else {
        this.refundDialog.visible = false;
      }
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    customDialog,
    priceCus
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.finDetails {
  .add_order {
    width: 114px;
    b {
      float: left;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
  .el-date-editor {
    margin-right: 20px;
  }
  .priceCus {
    .el-dialog {
      width: 500px;
    }
  }
}
</style>
